import axiosInstance from '../config/axios';

/**
 * Get recordings for user's assigned classes (GET /classes/recordings)
 */
export const getClassesRecordingsApi = () =>
  axiosInstance.get('/classes/recordings').then((res) => res.data);

/**
 * Add a recording to a class (POST /classes/:classId/recordings)
 * @param {string} classId
 * @param {Object} data - { recording_url }
 */
export const addClassRecordingApi = (classId, data) =>
  axiosInstance.post(`/classes/${classId}/recordings`, data).then((res) => res.data);

/**
 * Update a class recording (PUT /classes/recordings/:recordingId)
 * @param {string} recordingId
 * @param {Object} data - { recording_url }
 */
export const updateRecordingApi = (recordingId, data) =>
  axiosInstance.put(`/classes/recordings/${recordingId}`, data).then((res) => res.data);

/**
 * Delete a class recording (DELETE /classes/recordings/:recordingId)
 * @param {string} recordingId
 */
export const deleteRecordingApi = (recordingId) =>
  axiosInstance.delete(`/classes/recordings/${recordingId}`).then((res) => res.data);
